import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  timezone: {
    main: {
      format: "Europe/Amsterdam",
      name: {
        en: "CEST",
        ru: "CEST",
        de: "MESZ",
      },
    },
    msk: {
      format: "Europe/Moscow",
      name: {
        en: "MSK",
        ru: "МСК",
        de: "MZ",
      },
    },
  },
  dates: {
    registrationStart: "",
    broadcastsStart: "2021-10-04T09:00:00+03:00",
    registrationEnd: "",
    networkingDays: [],
  },
  error: "",
};

export default function Event(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Event.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Event.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Event.CLEAR:
      return { ...state, ...InitialState };
    default:
      return state;
  }
}
